(function () {
    'use strict';

    angular.module('thankview.freeTrial')
        .directive('freeTrialSetupForm', ['ajax', '$document', '$window', '$rootScope', function (ajax, $document, $window, $rootScope) {
            return {
                restrict: 'A',
                link: function (scope) {
                    scope.formParams = {
                        email: scope.formParams.email || '',
                        orgType: {
                            name: 'Choose your organization type',
                        },
                    };
                    scope.errorMessagesAll = {
                        pass: {
                            required: 'Please enter a password',
                            passLength: 'Password must be between 8 and 60 characters',
                        },
                        confirmPass: {
                            required: 'Please re-enter your password',
                            matchPass: 'The passwords do not match',
                        },
                        orgName: {
                            required: 'Type in your organization name',
                        },
                        orgType: {
                            required: 'Select your organization type',
                        },
                        customUrl: {
                            required: 'Type in your custom URL',
                            symbols: 'Custom URLs can only contain letters, numbers, and hyphens (-)',
                            duplicate: 'A portal with this custom URL already exists',
                        },
                        terms: {
                            required: 'Please agree to our terms and conditions',
                        },
                    };

                    scope.errorMessages = {
                        pass: '',
                        confirmPass: '',
                        orgName: '',
                        orgType: 'Select your organization type',
                        customUrl: '',
                        terms: 'Please agree to our terms and conditions',
                    };

                    scope.setIndustry = ($event, industry) => {
                        scope.industrySet = true;
                        scope.industryError = false;
                        scope.formParams.orgType = industry;
                    };

                    /**
                     * Set error message for given field based on priority of errors
                     *
                     * @param {String} field - Field name (must match name on input field on form)
                     */
                    scope.setErrorMessage = (field) => {
                        // Do nothing if scope vars not ready
                        if (!Object.keys(scope.errorMessages).length || !Object.keys(scope.errorMessagesAll).length) {
                            return;
                        }
                        const priority = {
                            required: 100,
                            passLength: 50,
                            matchPass: 10,
                            symbols: 20,
                            duplicate: 10,
                            default: 0,
                        };
                        const errors = Object.keys(scope.setupFreeTrial[field].$error);
                        let maxError = 'default';
                        errors.forEach((error) => {
                            if (priority[maxError] < priority[error]) {
                                maxError = error;
                            }
                        });
                        if (maxError === 'default') {
                            return;
                        }
                        scope.errorMessages[field] = scope.errorMessagesAll[field][maxError];
                    };

                    /**
                     * Determines whether to show error on template
                     *
                     * @param {Object} fieldObj - field object on form
                     */
                    // Might normally go in template, but Object.keys() not working there
                    scope.isShowError = (fieldObj) => {
                        if (fieldObj) {
                            return Object.keys(fieldObj.$error).length;
                        }
                        return 0;
                    };

                    /**
                     * Wrapper for angularJS $setValidity
                     *
                     * @param {String} field - Name attribute of input field
                     * @param {String} errorName - Name of error
                     * @param {Boolean} isValid - true if error is being removed and set to a valid state
                     */
                    scope.setValidity = (field, errorName, isValid) => {
                        scope.setupFreeTrial[field].$setValidity(errorName, isValid, 'setupFreeTrial');
                    };

                    scope.setErrors = () => {
                        // Required errors are set by AngularJS
                        if (scope.formParams.pass !== scope.formParams.confirmPass) {
                            scope.setValidity('confirmPass', 'matchPass', false);
                        } else {
                            scope.setValidity('confirmPass', 'matchPass', true);
                        }

                        if (scope.formParams.pass && (scope.formParams.pass.length < 8 || scope.formParams.pass.length > 60)) {
                            scope.setValidity('pass', 'passLength', false);
                        } else {
                            scope.setValidity('pass', 'passLength', true);
                        }

                        // eslint-disable-next-line no-undef
                        if (!validateSlug(scope.formParams.customUrl)) {
                            scope.setValidity('customUrl', 'symbols', false);
                        } else {
                            scope.setValidity('customUrl', 'symbols', true);
                        }

                        scope.setErrorMessage('pass');
                        scope.setErrorMessage('confirmPass');
                        scope.setErrorMessage('orgName');
                        scope.setErrorMessage('customUrl');
                        scope.setErrorMessage('terms');
                    };

                    // Watch the form and manually set some custom validation errors
                    scope.$watch('formParams', scope.setErrors, true);

                    // Scrolls to the first input that is invalid on the form
                    scope.scrollToError = () => {
                        const errEl = $document[0].querySelector('form[name="setupFreeTrial"] .ng-invalid');
                        if (errEl) {
                            $window.scrollTo(0, errEl.offsetTop - 75);
                            return true;
                        }
                        return false;
                    };

                    scope.submitSetupPage = () => {
                        if (scope.submittingForm) {
                            return;
                        }

                        scope.submittingForm = true;

                        ajax.get('/api/business/slugExists', { slug: scope.formParams.customUrl }).then((data) => {
                            if (data.exists) {
                                scope.setValidity('customUrl', 'duplicate', false);
                                scope.setErrors();
                                if (!scope.industrySet) {
                                    scope.industryError = true;
                                }
                                scope.scrollToError();
                                scope.submittingForm = false;
                                return;
                            }
                            scope.setValidity('customUrl', 'duplicate', true);
                            scope.setErrors();
                            if (!scope.industrySet) {
                                scope.industryError = true;
                            }
                            scope.scrollToError();
                            if (!scope.setupFreeTrial.$valid || !scope.industrySet || Object.keys(scope.setupFreeTrial.$error).length) {
                                scope.submittingForm = false;
                                return;
                            }

                            const urlArray = $window.location.pathname.split('/');
                            const params = {
                                email: scope.formParams.email,
                                password: scope.formParams.pass,
                                orgName: scope.formParams.orgName,
                                business_industry_id: scope.formParams.orgType.id,
                                slug: scope.formParams.customUrl.toLowerCase(),
                                leadId: urlArray[urlArray.length - 1],
                                terms: scope.formParams.terms,
                            };

                            ajax.post('/freeTrial', params).then((trialData) => {
                                // redirect user to their welcome page
                                $window.location = '/account';
                            }).catch(() => {
                                $rootScope.$broadcast('open-message', 'Something went wrong. Please contact customer support.', { showContact: true });
                            }).finally(() => {
                                scope.submittingForm = false;
                            });
                        });
                    };
                },
            };
        }]);
}());
